import administration from './pl/administration'
import calculations from './pl/calculations'
import campaigns from './pl/campaigns'
import common from './pl/common'
import cooperationJobs from './pl/cooperationJobs'
import configurations from './pl/configurations'
import customers from './pl/customers'
import cuttingJobs from './pl/cuttingJobs'
import documents from './pl/documents'
import jobs from './pl/jobs'
import jobsForProof from './pl/jobsForProof'
import maintenance from './pl/maintenance'
import notes from './pl/notes'
import orders from './pl/orders'
import packagePrototypeJobs from './pl/packagePrototypeJobs'
import prepress from './pl/prepress'
import purchases from './pl/purchases'
import quality from './pl/quality'
import reportingAndAnalysis from './pl/reportingAndAnalysis'
import reports from './pl/reports'
import shipments from './pl/shipments'
import shippingOrders from './pl/shippingOrders'
import wiki from './pl/wiki'

const messages = {
    // Modules
    common: common.messages,
    wiki: wiki.messages,
    configurations: configurations.messages,
    customers: customers.messages,
    jobs: jobs.messages,
    jobsForProof: jobsForProof.messages,
    packagePrototypeJobs: packagePrototypeJobs.messages,
    quality: quality.messages,
    administration: administration.messages,
    notes: notes.messages,
    orders: orders.messages,
    purchases: purchases.messages,
    reportingAndAnalysis: reportingAndAnalysis.messages,
    shipments: shipments.messages,
    campaigns: campaigns.messages,
    documents: documents.messages,
    reports: reports.messages,
    prepress: prepress.messages,
    calculations: calculations.messages,
    maintenance: maintenance.messages,
    cuttingJobs: cuttingJobs.messages,
    cooperationJobs: cooperationJobs.messages,
    shippingOrders: shippingOrders.messages,

    // Global usage
    global: {}
}

export default {
    messages: messages,
    locale: 'pl'
}
